<template>
  <Layout :tituloPagina="'Facturas'">
    <div class="row">
      <div class="col-lg-4">
        <cmp-secciones seccion="facturas"></cmp-secciones>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 col-2 mb-3">
        <button
          class="btn btn-secondary"
          @click="modalFiltrosListadoFacturas()"
        >
          <span class="d-none d-sm-block">
            <i class="fas fa-list-ul"></i>
            Filtros
          </span>
          <span class="d-block d-sm-none">
            <i class="fas fa-list-ul"></i>
          </span>
        </button>
      </div>
      <div class="col-md-8 col-8 mb-3">
        <filtrador
          v-on:dato-actualizado="
            dato = $event,
            refrescarFacturas()
          "
          :datoini="dato"
          placeholder="Dato de la factura"
        ></filtrador>
      </div>
      <div class="col-md-2 col-2 text-right">
        <router-link :to="{ name: 'nuevaFactura' }" class="btn btn-success">
          <span class="d-none d-sm-block">
            <i class="mdi mdi-plus-thick"></i>
            Nueva
          </span>
          <span class="d-block d-sm-none">
            <i class="mdi mdi-plus-thick"></i>
          </span>
        </router-link>
      </div>
    </div>
    <div class="text-right">
      <button class="btn btn-light btn-sm" @click="mostrarFacturasAnticipadas()">
        <i class="mdi mdi-cogs"></i>
        Facturas anticipadas
      </button>
    </div>
    <div class="row" style="padding-top: 10px">
      <div class="col-md-9">
        <div class="form-check font-size-16 d-inline-block">
          <input
            class="form-check-input"
            type="checkbox"
            id="creacion"
            v-model="columnas.fechaCreacion"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="creacion">Fecha de creación</label>
        </div>
        &nbsp;
        <div class="form-check font-size-16 d-inline-block">
          <input
            class="form-check-input"
            type="checkbox"
            id="pago"
            v-model="columnas.fechaPago"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="pago">Fecha para pago</label>
        </div>
        &nbsp;
        <div class="form-check font-size-16 d-inline-block">
          <input
            class="form-check-input"
            type="checkbox"
            id="vencimiento"
            v-model="columnas.fechaVencimiento"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="vencimiento">Fecha de vencimiento</label>
        </div>
        &nbsp;
        <div class="form-check font-size-16 d-inline-block">
          <input
            class="form-check-input"
            type="checkbox"
            id="corte"
            v-model="columnas.fechaCorte"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="corte">Fecha de corte</label>
        </div>
        &nbsp;
        <div class="form-check font-size-16 d-inline-block">
          <input
            class="form-check-input"
            type="checkbox"
            id="inicioFinPeriodo"
            v-model="columnas.inicioYFinPeriodo"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="inicioFinPeriodo">
            Inicio y fin de periodo
          </label>
        </div>
      </div>

      <div class="col-md-3 text-right">
        <span class="badge bg-secondary bg-gradient font-size-12">
          {{nFacturasEnPag}} facturas en página
        </span>
        <span class="badge bg-secondary bg-gradient font-size-12">
          {{nFacturasTotales}} facturas en total
        </span>
      </div>
    </div>
    <br />
    <div class="card">
      <div class="card-body" style="min-height: 475px;">
        <div class="table-responsive" style="min-height: 475px;">
          <table id="tabla-facturas" class="tblFacturas table table-hover table-nowrap align-middle">
            <thead>
              <tr>
                <th style="width: 50px">
                  <input
                    type="checkbox"
                    v-model="seleccionar_todo"
                    @change="seleccionarFacturas()"
                    :title="!seleccionar_todo ? 'Seleccionar todas las facturas' : 'Deseleccionar todas las facturas'"
                  />
                </th>
                <th style="width: 120px">Folio</th>
                <th style="min-width: 200px">Cliente</th>
                <th style="width: 100px" v-show="columnas.fechaCreacion">Fecha de creación</th>
                <th style="width: 100px" v-show="columnas.fechaPago">Fecha para pago</th>
                <th style="width: 100px" v-show="columnas.fechaVencimiento">Vencimiento</th>
                <th style="width: 100px" v-show="columnas.fechaCorte">Fecha de corte</th>
                <th style="width: 100px" v-show="columnas.inicioYFinPeriodo">Inicio de periodo</th>
                <th style="width: 100px" v-show="columnas.inicioYFinPeriodo">Fin de periodo</th>
                <th>Total</th>
                <th style="width: 100px">Saldo</th>
                <th style="width: 100px">Estado</th>
                <th style="width: 100px" class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="factura in facturas">
                <tr v-if="true" :key="'factura-'+factura.id">
                  <td>
                    <input
                      type="checkbox"
                      v-model="factura.seleccionar"
                      ref="seleccionarFactura"
                      @change="facturaSelec = !facturaSelec"
                      :disabled="factura.cancelada || factura.pagada"
                      :title="!factura.seleccionar ? 'Seleccionar factura' : 'Deseleccionar factura'"
                    />
                  </td>
                  <td class="fw-semibold">
                    <router-link :to="{ name: 'factura', params: { id: factura.id } }" class="me-1">
                      {{ factura.folio }}
                    </router-link>
                    <sup
                      title="Generada por sistema"
                      class="badge badge-pill badge-soft-info"
                      v-show="factura.generada_por_sistema == true"
                    >GS</sup>
                    <sup
                      title="Factura anticipada"
                      class="badge badge-pill badge-soft-dark"
                      v-show="factura.anticipada == true"
                    >FA</sup>
                    <sup
                      v-show="factura.prorroga > 0"
                      class="badge badge-pill badge-soft-success font-size-11 ms-1"
                      title="Tiene promesa de pago"
                    >P</sup>
                  </td>
                  <td>
                    <h5 class="font-size-14" :class="columnas.inicioYFinPeriodo ? 'text-truncate' : ''">
                      <router-link
                        :to="{
                          name: 'tableroCliente',
                          params: { id_cliente: factura.id_cliente }
                        }"
                        :title="factura.nombre_cliente"
                      >
                        {{ factura.nombre_cliente }}
                      </router-link>
                    </h5>
                  </td>
                  <td v-show="columnas.fechaCreacion">
                    {{ formatoFecha(factura.fecha+' '+factura.hora_creacion, 'DD/MM/YYYY - hh:mm A' ) }}
                  </td>
                  <td v-show="columnas.fechaPago" class="text-center">
                    <span v-if="factura.fecha_para_pago">
                      {{  formatoFecha(factura.fecha_para_pago) }}
                    </span>
                    <span style="color: #b3b5b6;" v-else>--</span>
                  </td>
                  <td v-show="columnas.fechaVencimiento" class="text-center">
                    <div v-if="factura.id_tipo_renta_contrato == 1">
                      <span
                        v-if="factura.fecha_vencimiento"
                        :class="{
                          'text-danger':
                            new Date(factura.fecha_vencimiento).getTime() -
                            new Date(fechaHoy).getTime() <= 0
                        }"
                      >
                        {{ formatoFecha(factura.fecha_vencimiento) }}
                      </span>
                      <span style="color: #b3b5b6;" v-else>--</span>
                    </div>
                    <span
                      v-if="factura.id_tipo_renta_contrato == 2"
                      title="Renta Mensual Variable"
                      class="badge bg-warning"
                    >
                      RMV
                    </span>
                  </td>
                  <td v-show="columnas.fechaCorte" class="text-center">
                    <div v-if="factura.id_tipo_renta_contrato == 1">
                      <span v-if="factura.fecha_para_pago">
                        {{ fecha_corte_servicio( factura.fecha_para_pago, factura.n_dias_corte ? factura.n_dias_corte : 0 ) }}
                      </span>
                      <span style="color: #b3b5b6;" v-else>--</span>
                    </div>
                    <div v-if="factura.id_tipo_renta_contrato == 2">
                      <span v-if="factura.fin_periodo">{{ formatoFecha(factura.fin_periodo) }}</span>
                      <span style="color: #b3b5b6;" v-else>--</span>
                    </div>
                  </td>
                  <td v-show="columnas.inicioYFinPeriodo" class="text-center">
                    <span v-if="factura.inicio_periodo">{{ formatoFecha(factura.inicio_periodo) }}</span>
                    <span style="color: #b3b5b6;" v-else>--</span>
                  </td>
                  <td v-show="columnas.inicioYFinPeriodo" class="text-center">
                    <span v-if="factura.fin_periodo">{{ formatoFecha(factura.fin_periodo) }}</span>
                    <span style="color: #b3b5b6;" v-else>--</span>
                  </td>
                  <td class="text-right">
                    {{ formatoMoneda(factura.total) }}
                  </td>
                  <td class="text-right">
                    <router-link
                      :to="{
                        name: 'abonosFactura',
                        params: { id_factura: factura.id }
                      }"
                    >
                      <strong>{{ formatoMoneda(factura.saldo) }}</strong>
                    </router-link>
                  </td>
                  <td>
                    <span
                      class="badge bg-success font-size-12"
                      v-show="factura.pagada && !factura.cancelada"
                    >
                      Pagada
                    </span>
                    <span
                      class="badge bg-warning font-size-12"
                      v-show="
                        !factura.pagada &&
                        !factura.cancelada &&
                        Number(factura.total.toFixed(2)) == Number(factura.saldo.toFixed(2))
                      "
                    >
                      Sin cobrar
                    </span>
                    <span
                      class="badge bg-soft-warning text-warning font-size-12"
                      v-show="
                        !factura.pagada &&
                        !factura.cancelada &&
                        Number(factura.total.toFixed(2)) > Number(factura.saldo.toFixed(2))
                      "
                    >
                      <b>Cobro parcial</b>
                    </span>
                    <span
                      class="badge bg-info font-size-12 ms-1 me-1"
                      v-show="
                        !factura.pagada &&
                        !factura.cancelada &&
                        factura.prorroga > 0
                      "
                    >
                      Promesa de pago
                    </span>
                    <button
                      v-show="
                        !factura.pagada &&
                        !factura.cancelada &&
                        factura.prorroga > 0
                      "
                      class="btn btn-light btn-sm pt-0 pb-0"
                      @click="palancaMostrarProrroga(factura)"
                    >
                      <i
                        class="mdi"
                        :class="{
                          'mdi-chevron-down': !factura.mostrar_prorroga, 
                          'mdi-chevron-up': factura.mostrar_prorroga
                        }"
                      ></i>
                    </button>
                    <span class="badge bg-danger bg-gradient font-size-12" v-show="factura.cancelada">
                      Cancelada
                    </span>

                    













                  </td>
                  <td class="text-center">
                    <router-link
                      :to="{
                        name: 'facturasPendientesPago',
                        params: { id_cliente: factura.id_cliente }
                      }"
                      class="btn btn-success btn-sm me-1"
                      v-if="
                        factura.pagada == false && factura.cancelada == false
                      "
                      title="Cobrar"
                    >
                      <i class="mdi mdi-cash"></i>
                    </router-link>
                    <router-link
                      :to="{ name: 'factura', params: { id: factura.id } }"
                      class="btn btn-info btn-sm me-1"
                      title="Ver"
                    >
                      <i class="mdi mdi-eye"></i>
                    </router-link>
                    <div class="dropdown d-inline-block">
                      <button
                        class="btn btn-light btn-sm dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="bx bx-dots-horizontal-rounded"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                          <button class="dropdown-item dark" @click="imprimirFactura(factura)">
                            <i class="mdi mdi-printer text-dark"></i>
                            Imprimir
                          </button>
                        </li>
                        <li>
                          <button
                            class="dropdown-item"
                            :class="factura.prorroga == 0 ? 'primary': 'danger'"
                            v-show="
                              !factura.cancelada && !factura.pagada && 
                              factura.fecha_vencimiento != null &&
                              factura.id_tipo_renta_contrato != 2
                            "
                            @click="factura.prorroga == 0 ? mostrarMdlProrrogaFactura(factura) : cancelarProrroga(factura)"
                          >
                            <i class="mdi mdi-clock-outline" :class="factura.prorroga == 0 ? 'text-primary': 'text-danger'"></i>
                            {{factura.prorroga == 0 ? 'Promesa de pago' : 'Cancelar promesa de pago'}}
                          </button>
                        </li>
                        <li>
                          <button
                            class="dropdown-item primary"
                            v-show="!factura.cancelada && factura.id_contrato == null"
                            @click="preguntaDuplicarFactura(factura)"
                          >
                            <i class="mdi mdi-content-duplicate text-primary"></i>
                            Duplicar
                          </button>
                        </li>
                        <li>
                          <button
                          class="dropdown-item danger"
                            v-show="!factura.cancelada && !factura.pagada"
                            @click="preguntaCancelarFactura(factura)"
                          >
                            <i class="mdi mdi-cancel text-danger"></i>
                            Cancelar
                          </button>
                        </li>
                        <li>
                          <button
                            class="dropdown-item danger"
                            v-show="factura.cancelada"
                            @click="preguntaEliminarFactura(factura)"
                          >
                            <i class="mdi mdi-trash-can-outline text-danger"></i>
                            Eliminar
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr v-if="factura.mostrar_prorroga" :key="'factura-prorroga-'+factura.id">
                  <td colspan="2">
                    <strong>Días después de la fecha de vencimiento:</strong> 
                    {{ factura.prorroga }} dia{{factura.prorroga==0?'':'s'}}
                  </td>
                  <td colspan="4">
                    <strong>Motivo de promesa de pago:</strong>
                    {{ factura.motivo_prorroga }}
                  </td>
                  <td colspan="4">
                    <strong>Promesa de pago aplicada por:</strong>
                    {{ factura.nombre_usuario_prorroga }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="text-start mt-3" v-if="mostrarCancelarFacturas > 0">
          <button
            @click="preguntaCancelarFacturas()"
            class="btn btn-outline-danger btn-sm"
            :title="mostrarCancelarFacturas == 1 ? 'Cancelar factura selecionada' : 'Cancelar factura seleccionadas'"
          >
            <i class="mdi mdi-cancel"></i>
            Cancelar
          </button>
        </div>
      </div>
    </div>
    <div class="text-center">
      <paginador
        :pag="pagina"
        :totpag="ultima_pagina"
        :epp="por_pagina"
        v-on:cargar-pagina="cargarPagina"
        v-on:epp-actualizado="
          por_pagina = $event,
          refrescarFacturas()
        "
      ></paginador>
    </div>
    <mdl-filtros
      ref="filtros"
      v-on:filtros-actualizados="actualizarFiltros"
    ></mdl-filtros>
    <mdl-prorroga-factura
      ref="mdlProrrogaFactura"
      v-on:prorroga-factura:gardada="refrescarFacturas()"
    />
    <mdl-facturas-anticipadas
      ref="modal_facturas_anticipadas"
      @facturas:anticipadas:actualizar="refrescarFacturas()"
    ></mdl-facturas-anticipadas>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue"
import CmpSecciones from './CmpSecciones.vue'
import MdlFiltros from './CmpModalFiltrosListadoFacturas.vue'
import Paginador from '@/components/Paginador.vue'
import Filtrador from '@/components/Filtrador.vue'
import SistemaSrv from '@/services/SistemaSrv.js'
import FacturaSrv from '@/services/FacturaSrv.js'
import MdlProrrogaFactura from './MdlProrrogaFactura.vue'
import MdlFacturasAnticipadas from "./MdlFacturasAnticipadas.vue"
import accounting from 'accounting/accounting.js'
import moment from 'moment'
import md5 from 'md5'
import API from '@/API.js'

import Swal from 'sweetalert2'
export default {
  name: 'ListadoFacturas',
  components: {
    Layout,
    CmpSecciones,
    MdlFiltros,
    Paginador,
    Filtrador,
    MdlProrrogaFactura,
    MdlFacturasAnticipadas
  },
  data() {
    return {
      API: API,
      token: localStorage.getItem('argusblack.token'),
      fechaHoy: null,
      baseUrl: window.location.origin,
      dato: '',
      facturas: [],
      filtros: ['no pagadas'],
      pagina: 1,
      por_pagina: parseInt(localStorage.getItem('argusblack.listadoFacturas.por_pagina') || 10),
      total: 0,
      ultima_pagina: 1,
      nFacturasEnPag:0,
      nFacturasTotales:0,
      fecha_pago: '',
      id_sitio: null,
      tipo_factura: 0,        // 0 = todos, 1 = renta mensual fija, 2 = renta mensual variable
      columnas: {
        fechaCreacion: true,
        fechaPago: true,
        fechaVencimiento: true,
        fechaCorte: false,
        inicioYFinPeriodo: false
      },
      seleccionar_todo: false,
      facturaSelec: false,
    }
  },
  computed: {
    monedaSistema: function() {
      return this.$store.state.todo.moneda_sistema
    },
    mostrarCancelarFacturas: function() {
      var self = this, facturas = []

      if(self.seleccionar_todo) facturas = self.facturas.filter(factura => factura.seleccionar == true)
      if(self.facturaSelec) facturas = self.facturas.filter(factura => factura.seleccionar == true)
      else facturas = self.facturas.filter(factura => factura.seleccionar == true)

      return facturas.length
    },
  },
  created: function() {
    var self = this

    // Carga de los querys
    if (self.$route.query.dato) self.dato = self.$route.query.dato
    if (self.$route.query.filtros) self.filtros = self.$route.query.filtros
    if (self.$route.query.pagina) self.pagina = parseInt(self.$route.query.pagina)
    if (self.$route.query.por_pagina) self.por_pagina = parseInt(self.$route.query.por_pagina)
    if (self.$route.query.fecha_pago) self.fecha_pago = self.$route.query.fecha_pago
    if (self.$route.query.id_sitio) self.id_sitio = parseInt(self.$route.query.id_sitio)
    if (self.$route.query.tipo_factura) self.tipo_factura = parseInt(self.$route.query.tipo_factura)

    // Carga inicial de las facturas
    self.refrescarFacturas()

    // Carga de la fecha de hoy
    SistemaSrv.fecha().then(response => {
      self.fechaHoy = response.data
    }).catch(error => {
      let mensaje
      try {
        mensaje = error.response.data.message
      } catch (e) {
        mensaje = ''
      }
      mensaje != '' ? iu.msg.error(mensaje) : null
      console.log(error)
    })

    // Carga de las columnas visibles
    self.cargarValoresColumnasDeLocalStorage()

    // Control de eventos
    iu.bus.on('filtros-actualizados', self.actualizarFiltros)
  },
  mounted: function() {
    iu.spinner.mostrar('#tabla-facturas')
  },
  methods: {
    actualizarFiltros: function(datos) {
      var self = this
      self.filtros = datos.filtros
      self.fecha_pago = datos.fecha_pago != '' ? moment(datos.fecha_pago, 'YYYY-MM-DD').format('YYYY-MM-DD') : ''
      self.id_sitio = datos.id_sitio
      self.tipo_factura = datos.tipo_factura
      
      self.refrescarFacturas()
    },

    actualizarValoresColumnasEnLocalStorage: function() {
      let self = this
      localStorage.setItem('argusblack.listadoFacturas.columnas', JSON.stringify(self.columnas))
    },

    cargarValoresColumnasDeLocalStorage: function() {
      let self = this
      let columnas = localStorage.getItem('argusblack.listadoFacturas.columnas')
      
      if(columnas == null) return

      columnas = JSON.parse(columnas)
      Object.assign(self.columnas, columnas)
    },

    cancelarFactura: function(idFactura, params) {
      let self = this
      params = params || {}

      FacturaSrv.cancelar(idFactura, params).then(response => {
        iu.msg.success('Factura cancelada correctamente.')
        self.refrescarFacturas()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cancelar'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarPagina: function(n) {
      var self = this
      self.pagina = n

      self.refrescarFacturas()
    },

    cancelarProrroga: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "¿Cancelar promesa de pago?",
        html: "¿Está seguro de cancelar la promesa de pago para la factura "+factura.folio+"?",
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          FacturaSrv.eliminarProrroga(factura.id).then(resopnse => {
            swal.fire("¡Promesa de pago cancelada!", "Promesa de pago de la factura "+factura.folio+" cancelada.", "success");
            self.refrescarFacturas()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = "No se pudo cancelar la promesa de pago de la factura "+factura.folio
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    fecha_corte_servicio: function(fecha_para_pago = '', n_dias_corte = 0) {
      if(fecha_para_pago == '') return ''
      return moment(fecha_para_pago, 'YYYY-MM-DD').add(n_dias_corte, 'days').format('DD/MM/YYYY')
    },

    formatoMoneda: function (numero) {
      return accounting.formatMoney(numero, { symbol: this.monedaSistema.simbolo, miles: ",", decimal: "." })+' '+this.monedaSistema.codigo
    },

    formatoFecha: function(mt, formato = 'DD/MM/YYYY') {
      return moment(mt, 'YYYY-MM-DD HH:mm:ss').format(formato)
    },

    imprimirFactura: function(factura) {
      let url = API+"/facturas/"+factura.id+"/impresion/"+md5(factura.id.toString())
      window.open(url,'_blank')
    },

    modalFiltrosListadoFacturas: function() {
      var self = this,
      params = {
        filtros: self.filtros,
        fecha_pago: self.fecha_pago,
        id_sitio: self.id_sitio,
        tipo_factura: self.tipo_factura
      }
      this.$refs.filtros.mostrar(params)
    },
    
    mostrarMdlProrrogaFactura: function(factura) {
      this.$refs.mdlProrrogaFactura.mostrar(factura)
    },

    mostrarFacturasAnticipadas: function () {
      var self = this
      self.$refs.modal_facturas_anticipadas.mostrar()
    },

    palancaMostrarProrroga: function(factura) {
      if (factura.mostrar_prorroga) factura.mostrar_prorroga = false
      else factura.mostrar_prorroga = true
    },

    preguntaEliminarFactura: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "Eliminación de factura",
        html: '¿Desea elimnar la factura <strong>' + factura.folio + '</strong> ' +
          'del cliente <strong>' + factura.nombre_cliente + '</strong>?',
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          FacturaSrv.eliminar(factura.id).then(resopnse => {
            swal.fire("Eliminado!", "Se eliminó correctamente", "success");
            self.refrescarFacturas()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = 'No se pudo eliminar la factura'
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    preguntaDuplicarFactura: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "Duplicar factura",
        html: '¿Desea duplicar la factura <strong>' + factura.folio + '</strong> ' +
          'del cliente <strong>' + factura.nombre_cliente + '</strong>?',
        icon: "question",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          FacturaSrv.duplicar(factura.id).then(resopnse => {
            swal.fire("Duplicado!", "Se ha duplicado la factura correctamente", "success");
            self.refrescarFacturas()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = 'No se pudo duplicar la factura'
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    preguntaCancelarFactura: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "Cancelación de factura",
        html: '¿Desea cancelar la factura <strong>'+factura.folio+'</strong> '+'del cliente <strong>'+factura.nombre_cliente+'</strong>?',
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          if(factura.id_contrato != null && factura.fecha_para_pago != null) {
            swal.fire("¡Cancelación de factura!", "Cancelación de factura "+factura.folio, "success")
            setTimeout(function(){
              swal.fire({
                title: 'Regeneración de factura',
                html: '¿Deseas que el sistema vuelva a regenerar la factura?',
                icon: "info",
                confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
                cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
                showCancelButton: true
              }).then(result => {
                if (result.value) {
                  self.cancelarFactura(factura.id, {regenerar: true})
                } else if ( result.dismiss === Swal.DismissReason.cancel ) {
                  self.cancelarFactura(factura.id)
                }
              })
            }, 300)
          } else {
            self.cancelarFactura(factura.id)
          }
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error")
        }
      })
    },

    preguntaCancelarFacturas: function() {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "Cancelar las facturas",
        html: '¿Desea cancelar la facturas seleccionadas?',
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          let facturasContrato = self.facturas.filter(factura => 
            factura.seleccionar === true &&
            factura.id_contrato != null &&
            factura.fecha_para_pago != null
          )

          let facturaSinContrato = self.facturas.filter(factura => 
            factura.seleccionar === true &&
            (factura.id_contrato == null || factura.fecha_para_pago == null)
          )

          // Construcción de tablas
          const tablaRegenerar = `
            <h6 class="mt-2">Facturas que SI podrán regenerarse</h6>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th style="width: 100px">Folio</th>
                  <th>Cliente</th>
                </tr>
              </thead>
              <tbody>
                ${
                  facturasContrato.length ? 
                  facturasContrato.map(f => `
                    <tr>
                      <td>${f.folio}</td>
                      <td>${f.nombre_cliente || ''}</td>
                    </tr>
                  `).join('') : 
                  `<tr><td colspan="2">Sin registros</td></tr>`
                }
              </tbody>
            </table>
          `
          const tablaNoRegenerar = `
            <h6 class="mt-3 text-danger">Facturas que NO se regenerarán</h6>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th style="width: 100px">Folio</th>
                  <th>Cliente</th>
                </tr>
              </thead>
              <tbody>
                ${
                  facturaSinContrato.length ?
                  facturaSinContrato.map(f => `
                    <tr>
                      <td>${f.folio}</td>
                      <td>${f.nombre_cliente || ''}</td>
                    </tr>
                  `).join('') : 
                  `<tr><td colspan="2">Sin registros</td></tr>`
                }
              </tbody>
            </table>
          `
          swal.fire({
            title: 'Regeneración de factura',
            html: `
              <p>Las siguientes facturas serán canceladas:</p>
              <div style="max-height:350px; overflow:auto; text-align:left;">
                ${tablaRegenerar}
                ${tablaNoRegenerar}
              </div>
              <p class="mt-2">¿Deseas que el sistema vuelva a regenerar las facturas aplicables?</p>
            `,
            icon: "info",
            width: 750,
            confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
            cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
            showCancelButton: true
          }).then(result => {
            if (result.value) {
              // cancelar con regeneración solo las que aplican
              facturasContrato.forEach(f => {
                self.cancelarFactura(f.id, { regenerar: true })
              })
              // cancelar sin regenerar las que no aplican
              facturaSinContrato.forEach(f => {
                self.cancelarFactura(f.id)
              })
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              // cancelar todas sin regenerar
              [...facturasContrato, ...facturaSinContrato].forEach(f => {
                self.cancelarFactura(f.id)
              })
            }
          })
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error")
        }
      })
    },

    preguntaDescargarCfdiPdf: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "Descargar CFDI en PDF",
        html: "¿Desea descargar CFDI de la factura <br><b>"+factura.folio+"</b><br> en formato PDF?",
        icon: "question",
        confirmButtonText: "Si descargar!",
        cancelButtonText: "No descargar!",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          swal.fire("¡Descargando!", "Descargando CFDI en pdf de la factura "+factura.folio, "success")
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error")
        }
      })
    },

    preguntaDescargarCfdiXml: function (factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "Descargar CFDI en XML",
        html: "¿Desea descargar CFDI de la factura <br><b>"+factura.folio+"</b><br> en formato XML?",
        icon: "question",
        confirmButtonText: "Si descargar!",
        cancelButtonText: "No descargar!",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          swal.fire("¡Descargando!", "Descargando CFDI en XML de la factura "+factura.folio, "success")
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error")
        }
      })
    },

    preguntaReenviarCfdi: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "¿Reenviar CFDI por correo?",
        html: `¿Está seguro de reenviar el CFDI de la factura <strong>${factura.folio}</strong> por correo?`,
        icon: "question",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          self.preguntarCorreo(factura)
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    preguntarCorreo: function(factura) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      })

      swal.fire({
        title: "Motivo de cancelación",
        html: "Escriba el motivo de la cancelación:",
        input: "email",
        inputPlaceholder: "Escribe algo",
        inputValue: 'ejemplo@ejemplo.com',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "#f46a6a",
        allowOutsideClick: false,
        didOpen: () => {
          const input = Swal.getInput()
          if (input) {
            input.style.color = this.$store.state.layout.layoutMode == 'dark' ? "#d9e3f3" : "#545454"
          }
        }
      }).then(text => {
        if (text.value) {
          swal.fire("Renviado!", `Se reenvio correctamente el CFDI <br><br> <div style="text-align: justify;">factura: <strong>${factura.folio}</strong> <br> correo: <strong>${text.value}</strong></div>`, "success");
        } else if ( text.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    seleccionarFacturas: function() {
      this.facturas.forEach(factura => {
        if(!factura.cancelada && !factura.pagada) 
          factura.seleccionar = this.seleccionar_todo
      })
    },

    refrescarFacturas: function() {
      var self = this,filtros =[]

      iu.spinner.mostrar('#tabla-facturas')

      if(typeof self.filtros == 'string') {
        if (self.filtros.indexOf('\"no pagadas\"') != -1) filtros.push('no pagadas')
        if (self.filtros.indexOf('\"pagadas\"')    != -1) filtros.push('pagadas')
        if (self.filtros.indexOf('\"canceladas\"') != -1) filtros.push('canceladas')
        if (self.filtros.indexOf('\"vencidas\"')   != -1) filtros.push('vencidas')
        if (self.filtros.indexOf('\"sistema\"')    != -1) filtros.push('sistema')
        if (self.filtros.indexOf('\"manuales\"')   != -1) filtros.push('manuales')
        if (self.filtros.indexOf('\"prorrogas\"')  != -1) filtros.push('prorrogas')

        self.filtros = filtros
      } else filtros = self.filtros

      let query = {
        dato: self.dato,
        filtros: JSON.stringify(filtros),
        pagina: self.pagina,
        por_pagina: self.por_pagina,
        id_sitio: self.id_sitio,
        tipo_factura: self.tipo_factura
      }

      let params = {
        filtros: filtros,
        dato: self.dato,
        pagina: self.pagina,
        por_pagina: self.por_pagina,
        id_sitio: self.id_sitio,
        tipo_factura: self.tipo_factura,
        orden: 'desc'
      }

      if(self.fecha_pago != '' ){
        Object.assign(query, {
          fecha_pago: self.fecha_pago
        })

        Object.assign(params, {
          fecha_pago: self.fecha_pago
        })
      }

      self.$router.replace({query: query}).catch(error => {})

      FacturaSrv.vfacturas1JSON(params).then(response => {
        localStorage.setItem('argusblack.listadoFacturas.por_pagina', self.por_pagina)
        let res = response.data
        self.pagina = res.pagina
        self.total = res.total
        self.ultima_pagina = res.ultima_pagina

        let facturas = res.facturas
        facturas.forEach(function(factura) {
          factura.mostrar_prorroga = false
          factura.seleccionar = false
        })

        self.facturas = facturas
        self.nFacturasEnPag = res.nFacturasEnPag
        self.nFacturasTotales = res.total
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron cargar las facturas'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(fin => {
        iu.spinner.ocultar('#tabla-facturas')
      })
    }
  }
}
</script>

<style scoped>
.text-truncate {
  width: 180px;
}
</style>
